<template>
    <div>
        <Breadcrumbs main="Admin" submain="Portfolio" title="Training" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add Training</h7>
                            </button>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="training_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(image)="row">
                                            <img :src="host + row.item.image" alt="" style="width: 120px; height: 80px;">
                                        </template>
    
                                        <template #cell(title)="row">
                                            <div v-if="row.item.title">
                                                <p>{{ row.item.title }}</p>
                                            </div>
                                        </template>
    
                                        <template #cell(subject)="row">
                                            <div v-if="row.item.subject">
                                                <p>{{ row.item.subject }}</p>
                                            </div>
                                        </template>
    
                                        <!-- <template #cell(link)="row">
                                            <div v-if="row.item.link">
                                                <a :href="row.item.link" target="_blank" class="link-style">{{ row.item.link.substring(0,40) }}</a>
                                            </div>
                                            <div v-else>
                                                N/A
                                            </div>
                                        </template> -->
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteTraining(data.item.id)" title="Delete"></feather>
                                                </div>
                                                <div @click="editTraining(data.item)">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Training Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Training" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Degree/Training</label>
                            <input class="form-control" type="text" placeholder="Enter Degree/Training" v-model="training.title">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Passing/Completed Year</label>
                            <input class="form-control" type="text" placeholder="Enter Passing/Completed Year" v-model="training.year">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Major Subject</label>
                            <input class="form-control" type="text" placeholder="Enter Major Subject" v-model="training.subject">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Institute</label>
                            <input class="form-control" type="text" placeholder="Enter Institute" v-model="training.institute">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Country</label>
                            <input class="form-control" type="text" placeholder="Enter Country" v-model="training.country">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Training Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Training" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Degree/Training</label>
                            <input class="form-control" type="text" placeholder="Enter Degree/Training" v-model="edit_training.title">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Passing/Completed Year</label>
                            <input class="form-control" type="text" placeholder="Enter Passing/Completed Year" v-model="edit_training.year">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Major Subject</label>
                            <input class="form-control" type="text" placeholder="Enter Major Subject" v-model="edit_training.subject">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Institute</label>
                            <input class="form-control" type="text" placeholder="Enter Institute" v-model="edit_training.institute">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Country</label>
                            <input class="form-control" type="text" placeholder="Enter Country" v-model="edit_training.country">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Gallery Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this training?</div>
        </b-modal>
    </div>
</template> 
        
<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import Datepicker from 'vuejs-datepicker';
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import moment from "moment";
    import { mapState } from 'vuex';
    import loader from '../loader/loader.vue';
    import { VueEditor } from "vue2-editor";
    
    export default {
        components: {
            Datepicker,
            loader,
            VueEditor
        },
    
        data() {
            return {
                editor: ClassicEditor,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'title',
                        label: 'Degree/Training',
                        sortable: true
                    },
                    {
                        key: 'subject',
                        label: 'Major Subject',
                        sortable: true
                    },
                    {
                        key: 'institute',
                        label: 'Institute',
                        sortable: true
                    },
                    {
                        key: 'country',
                        label: 'Country',
                        sortable: true
                    },
                    {
                        key: 'year',
                        label: 'Passing/Completed Year',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
                training: {
                   title:'',
                   year:'',
                   subject:'',
                   institute:'',
                   country:''
                },
    
                edit_training: {
                    id: '',
                    title:'',
                    year:'',
                    subject:'',
                    institute:'',
                    country:''
                },
    
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [5, 10, 15]
            };
        },
    
        computed: {
            ...mapState({
                training_list: state => state.training.training,
                loading: state => state.training.trainingLoading,
                error: state => state.training.trainingError
            }),
    
            sortOptions() {
                return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
            }
        },
    
        mounted() {
            this.$store.dispatch("training/fetchTraining").then(() => {
                this.items = this.training_list
                this.totalRows = this.items.length;
            });
        },
    
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.training.title = null
                this.training.year = null
                this.training.subject = null
                this.training.institute = null
                this.training.country = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("training/addTraining", {
                    training: this.training
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.training.title = null
                        this.training.year = null
                        this.training.subject = null
                        this.training.institute = null
                        this.training.country = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editTraining(detail) {
                this.edit_training.id = detail.id ? detail.id : null
                this.edit_training.title = detail.title ? detail.title : null
                this.edit_training.year = detail.year ? detail.year : null
                this.edit_training.subject = detail.subject ? detail.subject : null
                this.edit_training.institute = detail.institute ? detail.institute : null
                this.edit_training.country = detail.country ? detail.country : null
            },
    
            resetEditModal() {
                this.edit_training.title = null
                this.edit_training.year = null
                this.edit_training.subject = null
                this.edit_training.institute = null
                this.edit_training.country = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.$store.dispatch("training/updateTraining", {
                    id: this.edit_training.id,
                    training: this.edit_training,
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.edit_training.title = null
                        this.edit_training.year = null
                        this.edit_training.subject = null
                        this.edit_training.institute = null
                        this.edit_training.country = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteTraining(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("training/deleteTraining", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    